import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  container: {
    marginLeft: theme.spacing(2),
    maxHeight: "calc(100vh - 140px)",
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      maxHeight: "calc(100% - 120px)",
    },
  },
}))

export default styles
